export default "/images/vendor/flag-icon-css/flags/4x3/ai.svg?cddfccfb8735e7bb6cdabcd5c7b6e713";